module.exports = __webpack_public_path__ + "static/notification1-9edc3781d6c5bc2f048ec53b01ba5ddc.png";